import { defineStore } from 'pinia'
import { createAuthDialog } from '@/components/restructure/authTipsDialog'
import { getAccountAuthStatus } from '@/apis/auth'
export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      rechargeData: {
        visible: false,
        accountId: '', // 新系统充值账号
        newSystem: 1, // 1是0否
        remain: 0,
        voucher: 0,
        reload: () => {}
      }, // 充值弹窗
      accountAuthDrawDialog: false, // 实名认证弹框状态
      accountAuthData: null // 个人实名扫脸结果
    }
  },
  actions: {
    // 检测登录账号是否实名认证
    async setRechargeVisible({ newSystem = 1, accountId = '', remain = 0, voucher = 0 }, reload) {
      const { open, setData, close } = createAuthDialog()
      const data = await getAccountAuthStatus()
      switch (data.authStatus) {
        case 2:
          this.rechargeData = {
            visible: true,
            accountId,
            remain,
            voucher,
            newSystem,
            reload
          }
          break
        case 0:
          // 未实名认证
          open({
            showWarnTip: true,
            warnTipInfo: {
              title: '提示',
              type: 'warn',
              toolText: '去实名认证',
              mainContent: '您还未做实名认证'
            },
            onCallbackTool: () => {
              // 弹出实名认证弹框
              setData({ showWarnTip: false })
              this.accountAuthDrawDialog = true
            },
            onClose: () => {
              setData({ showWarnTip: false })
              close()
            }
          })
          break
        case 1:
          // 认证审核中
          open({
            showWarnTip: true,
            warnTipInfo: {
              title: '提示',
              type: 'pending',
              toolText: '',
              mainContent: '实名认证资料审核中，请审核通过后再充值'
            },
            onClose: () => {
              setData({ showWarnTip: false })
              close()
            }
          })
          break
        case 3:
          // 认证失败
          open({
            showWarnTip: true,
            warnTipInfo: {
              title: '提示',
              type: 'faile',
              toolText: '查看原因',
              mainContent: '请前往“个人头像-资料设置-个人资料-认证详情”进行认证'
            },
            onCallbackTool: () => {
              // 弹出实名认证弹框
              this.accountAuthDrawDialog = true
            },
            onClose: () => {
              setData({ showWarnTip: false })
              close()
            }
          })
          break
      }
    }
  }
})
